module.exports = __webpack_public_path__ + "img/imp1.5b018acb.png";